import React from "react";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import {Divider} from "@material-ui/core";
import NumberFormat from "react-number-format";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";

const EditParameters = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    {props.messagesGrowl}
                    <Grid item xs={8}>
                        <TitlePage title="Administración \ Facturación \ Editar Parámetros"/>
                    </Grid>
                    <Grid item xs={4} style={{textAlign: "right"}}>
                        <Button label="Regresar"
                                onClick={props.returnInvoice}
                                className="p-button-secondary"/>&nbsp;
                        <Button label="Guardar"
                                onClick={props.updatePercent}/>
                    </Grid>
                    <Grid item xs={12}> <Divider/> </Grid>
                    <Grid item xs={12}>
                        <SubtitleLabel header="Actuando como" isBold={true}/>
                    </Grid>

                    <Grid item xs={12}>
                        <div className="p-grid">
                            <div className="p-col-3">
                                <SubtitleLabel header="Prestamista" isBold={true}/>
                                <NumberFormat
                                    name="percentPtm"
                                    className={"p-inputtext p-component p-filled"}
                                    value={props.percentPtm.porcentaje}
                                    thousandSeparator={true}
                                    onChange={props.saveDataPercent}
                                    maxLength={8}
                                    decimalScale={2}
                                    allowNegative={false}
                                />
                            </div>
                            <div className="p-col-3">
                                <SubtitleLabel header="Prestatario" isBold={true}/>
                                <NumberFormat
                                    name="percentPtt"
                                    className={"p-inputtext p-component p-filled"}
                                    value={props.percentPtt.porcentaje}
                                    thousandSeparator={true}
                                    onChange={props.saveDataPercent}
                                    maxLength={8}
                                    fixedDecimalScale={true}
                                    allowNegative={false}
                                />
                            </div>
                        </div>
                    </Grid>
                    <Divider/>
                    <SubtitleLabel header="Lista de Instituciones" isBold={true}/>
                    <Grid item xs={12}>
                        <DataTable
                            value={props.institutionList}
                            responsive={true}
                            selectionMode={"single"}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column
                                field="NomCorto"
                                header="Institución"
                                style={{textAlign: 'left'}}
                                sortable={true}/>
                            <Column
                                field="TipoFactura"
                                header="Tipo Facturación"
                                style={{textAlign: 'left'}}
                                sortable={true}/>
                            <Column
                                header="Acciones"
                                body={props.institutionInvoiceActionTemplate}
                                style={{textAlign: 'right'}}
                            />
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default EditParameters;